export default {
  collapsedMenu(state) {
    return state.collapsed
  }
}
